import { ResourceLoader } from "../../earth/core/resourceLoader";
import { Publication } from "../model/publication";

export class PublicationsService {
    private static _instance: PublicationsService | null = null;
    private _allPublications: Publication[] = [];

    static get instance() {
        if (!PublicationsService._instance) {
            PublicationsService._instance = new PublicationsService();
        }
        return PublicationsService._instance;
    }

    async loadPublications(): Promise<void> {
         this._allPublications = await PublicationsService.loadPublications("assets/app/metrics/posts.json");
    }

    public getPublicationsByLikes(): Publication[] {
        return this._allPublications;
    }

    private static async loadPublications(jsonPath: string): Promise<Publication[]> {
        let json = await ResourceLoader.loadAsJson(jsonPath);
        return PublicationsService.jsonToPublications(json);
    }

    private static jsonToPublications(json: any): Publication[] {
        let publications: Publication[] = [];
        for (let postList of json.filter(it => it != null)) {
            for (let entry of postList.entries) {
                if (entry.result_attributes["images.url"] != undefined) {
                    publications.push(new Publication(entry.result_attributes["images.url"], entry.result_attributes.parent_url, entry.result_attributes.engagement));
                }
            }
        }
        return publications;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/services/publicationsService.ts